/**
 * Адреси, вкладки, повернення (UX-04…08): недавні записи, крихти й перехід між записами подання,
 * повернення до списку. Не входить у зведений `uk.ts`: його тягне документ входу, а цих текстів
 * там немає. Імпортувати напряму; перетин ключів перевіряє `uk.test.ts`.
 */
export const navigation = {
  recentClear: 'Очистити недавні записи',
  recentCleared: 'Недавні записи очищено',
  recentClearFailed: 'Не вдалося очистити недавні записи. Спробуйте ще раз',

  crumbsLabel: 'Ви тут',
  /** «8 з 86»; є ще сторінки — «8 з 100+» (точного числа понад завантажене не рахуємо). */
  positionOf: (n: number, total: number, more: boolean) => `${n} з ${total}${more ? '+' : ''}`,
  positionLabel: (n: number, total: number, more: boolean) =>
    `Запис ${n} з ${total}${more ? '+' : ''} у поданні`,
  recordPrev: 'Попередній запис',
  recordNext: 'Наступний запис',
  recordFirstHint: 'Це перший запис подання',
  recordLastHint: 'Це останній запис подання',

  /** Повернення до списку: читач екрана чує назву списку й номер рядка (UX-08). */
  listReturned: (list: string, n: number, total: number) => `${list}, рядок ${n} з ${total}`,
} as const;
